import React from 'react';
import { useLocation } from 'react-router-dom';
import { CONST_REPORT_TABS_NEW_COLUMNS } from '../../common/reportsConstants';
import { CommonPage } from '../reports-new';
export default function Order() {
  const location = useLocation();
  let tabKey = '';
  const strCurrPath = location.pathname.replace('/', '').split('/');
  if(strCurrPath[0] === 'orders'){
    tabKey = 'Orders';
  }else{
    tabKey = 'Future Orders';
  }
  const columnsProp = CONST_REPORT_TABS_NEW_COLUMNS.filter(item => item.key === tabKey)[0].order.columns;
  const level = CONST_REPORT_TABS_NEW_COLUMNS.filter(item => item.key === tabKey)[0].order.level;
  return (
    <div className="orders-order">
      <CommonPage tabKey={tabKey} columnsProp={columnsProp} level={level} />
    </div>
  );
};

Order.propTypes = {};
Order.defaultProps = {};
